import React from 'react';
import Modal from 'apps/web_forms/components/commons/Modal';
import styled from 'styled-components';
import { ids } from 'apps/web_forms/utils/constants';

const ModalContent = styled.div`
  font-family: 'Helvetica', 'Roboto', sans-serif;
  text-align: center;
  font-size: 13px;
  color: #333;
  padding: 20px;
  max-width: 550px;
  margin: auto;
`;

export const ExitPageModal = ({ extraProps }) => {
  // Destructure from extraProps (like ResourceUpdateConfirmationModal)
  const {
    pendingNavigation,     // from history.block callback
    setExitPageModalOpen,  // function to "close" this modal
  } = extraProps || {};

  const leavePage = () => {
    // 1) Close the modal
    if (typeof setExitPageModalOpen === 'function') {
      setExitPageModalOpen(false);
    }
    // 2) Continue the blocked navigation
    if (pendingNavigation && typeof pendingNavigation.retry === 'function') {
      pendingNavigation.retry();
    }
  };

  const cancelLeave = () => {
    // Just close the modal, do not navigate
    if (typeof setExitPageModalOpen === 'function') {
      setExitPageModalOpen(false);
    }
  };

  return (
    <Modal
      mainMessage=""
      helpTip={
        <ModalContent>
          {"Are you sure you want to navigate away? To avoid lost data, save as draft."}
        </ModalContent>
      }
      isOpen={true} // same style as other modals
      setIsOpen={cancelLeave} // close if user clicks outside, etc.
      testId={ids.ExitModalIds?.MainTestId || 'exit-page-modal'}
      buttons={[
        {
          id: ids.ExitModalIds?.CancelButton || 'exit-modal-cancel',
          label: 'Cancel',
          onClick: cancelLeave,
          filled: false,
        },
        {
          id: ids.ExitModalIds?.LeaveButton || 'exit-modal-leave',
          label: 'Leave',
          onClick: leavePage,
          filled: true,
        },
      ]}
    />
  );
};
